export default __webpack_public_path__ + "static/media/girl.5cbfc27a.png";